import { AppSidebar } from "@/components/app-sidebar";
import { SiteHeader } from "@/components/site-header";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useCurrentSubscription } from "@/hooks/useCurrentSubscription";
import { Info, TriangleAlert } from "lucide-react";
import { Link } from "react-router-dom";

export function SubscriptionAlert({
  subscription,
  plan,
  status,
  daysLeft,
  loading,
}: any) {
  if (loading || status === "none") return null;

  if (status === "expired") {
    return (
      <Alert variant="destructive">
        <TriangleAlert className="h-4 w-4" />
        <AlertTitle>
          {plan === "PLAN GRATIS" ? (
            <>Plan Gratis superado</>
          ) : (
            <>Tu suscripción ha vencido</>
          )}
        </AlertTitle>
        <AlertDescription>
          {plan === "PLAN GRATIS" ? (
            <>
              <Link to="/pricing">
                Alcanzo el limite de cuentas, si gusta puede subir de plan aquí
              </Link>
            </>
          ) : (
            <>
              Tu acceso expiró el{" "}
              {new Date(subscription?.next_payment_date).toLocaleDateString()}.
              Renueva para seguir usando la plataforma.
            </>
          )}
        </AlertDescription>
      </Alert>
    );
  }

  if (daysLeft !== null && daysLeft <= 5) {
    return (
      <Alert variant="default">
        <Info className="h-4 w-4" />
        <AlertTitle>¡Tu suscripción vence pronto!</AlertTitle>
        <AlertDescription>
          Faltan {daysLeft} día{daysLeft === 1 ? "" : "s"} para que expire tu
          plan.
        </AlertDescription>
      </Alert>
    );
  }

  return null;
}

const Layout2 = ({ children, name }: any) => {
  const { plan, status, daysLeft, loading } = useCurrentSubscription();
  return (
    <SidebarProvider>
      <AppSidebar variant="inset" />
      <SidebarInset>
        <SiteHeader name={name} plan={plan} status={status} />
        <div className="px-6 pt-3">
          <SubscriptionAlert
            plan={plan}
            status={status}
            daysLeft={daysLeft}
            loading={loading}
          ></SubscriptionAlert>
        </div>
        {children}
      </SidebarInset>
    </SidebarProvider>
  );
};

export default Layout2;
